import FormQuestion from './components/form-question';

class App extends React.Component {
  render() {
        return (<div>
          <FormQuestion/>
        </div>);
    }
};

ReactDOM.render(
  <App />,
  document.getElementById('app')
);


// WEBPACK FOOTER //
// in/js/app.js